"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRuleSetAccountDataSerializer = void 0;
const generated_1 = require("../generated");
const revisions_1 = require("../revisions");
const getRuleSetAccountDataSerializer = () => ({
    description: 'RuleSetAccountData',
    fixedSize: null,
    maxSize: null,
    serialize: () => {
        throw new Error('Operation not supported.');
    },
    deserialize: (buffer, offset = 0) => {
        // Header and revision map.
        const [header] = (0, generated_1.getRuleSetHeaderSerializer)().deserialize(buffer, offset);
        if (header.key !== generated_1.Key.RuleSet) {
            throw new Error(`Expected a RuleSet account, got account data key: ${header.key}`);
        }
        const revisionMapLocation = Number(header.revMapVersionLocation);
        const [revisionMap, finalOffset] = (0, revisions_1.getRuleSetRevisionMapSerializer)(revisionMapLocation).deserialize(buffer, offset + revisionMapLocation);
        // Revisions.
        const revisions = revisionMap.revisionLocations.map((location, index) => {
            const revisionStart = offset + location;
            const revisionEnd = offset +
                (revisionMap.revisionLocations[index + 1] ?? revisionMapLocation);
            const revisionSlice = buffer.slice(revisionStart, revisionEnd);
            return (0, revisions_1.getRuleSetRevisionSerializer)().deserialize(revisionSlice)[0];
        });
        return [
            {
                key: generated_1.Key.RuleSet,
                latestRevision: revisions[revisions.length - 1],
                revisions,
                revisionMap,
            },
            finalOffset,
        ];
    },
});
exports.getRuleSetAccountDataSerializer = getRuleSetAccountDataSerializer;
//# sourceMappingURL=ruleSetAccountData.js.map